import { language } from '../services/LanguageService';
/**
 * Default page sizes for the DataTable component
 */
export const defaultPageSizes = [
    { value: 10, text: 10 },
    { value: 25, text: 25 },
    { value: 50, text: 50 },
    { value: 100, text: 100 },
];
/**
 * Prefix to add to all errors from AsperaError class
 */
export const errorPrefix = 'Aspera Error';
/**
 * Default English Language
 */
export const defaultEnglish = ['en-us', {
        code: 'en-us',
        name: 'English (United States)',
        dateFormat: 'm/d/Y',
        npsKey: 'en',
    }];
/**
 * Storage keys for localStorage
 */
export const storageKeys = {
    /** Used to indicate if dark mode is enabled */
    darkMode: 'aspera-dark-mode',
    /** Used for tracking aspera transfers (Node2Node) */
    transfers: 'aspera-transfers',
    /** Used to store the language key in memory */
    language: 'aspera-language',
    /** Used to indicate if language test mode (see keys) should be used */
    languageTest: 'aspera-language-test',
    /** Used for tracking table data */
    tableData: 'aspera-table-data',
    /** Used for tracking table data */
    tableDataCustomization: 'aspera-table-data-customizations',
    /** HTTP Gateway Server URL Local Override */
    httpGatewayServerUrl: 'aspera-http-gateway-server-url',
    /** Indicate if user has skipped transfer system */
    skipTransferSystem: 'aspera-skip-transfer-system',
    /** Indicate if user has already seen welcome modal for transfer system */
    skipTransferSystemWelcome: 'aspera-skip-transfer-welcome',
    /** Indicate user wanted to use web for mobile prompt */
    ignoreMobilePrompt: 'aspera-ignore-mobile-prompt',
    /** Indicate that the mobile toast notification has been shown this session */
    mobileTransferNotification: 'aspera-mobile-toast',
    /** Indicate that the user has selected a transfer system */
    transferSystemChoice: 'aspera-transfer-system-choice',
    /** Indicate that the user has enabled multi user for transfer system */
    enableDesktopMultiUser: 'aspera-enable-desktop-multi-user',
};
/** Body class for full page/create flow wrapper */
export const fullPageModeClass = 'aspera-full-page-view';
/**
 * Get all timezone items
 *
 * @returns list of offsets with offset in hours and name of timezone (translated)
 */
export const getTimezoneList = () => {
    return [
        {
            offset: -720,
            name: language.get('timezone.timeN720'),
        },
        {
            offset: -660,
            name: language.get('timezone.timeN660'),
        },
        {
            offset: -600,
            name: language.get('timezone.timeN600'),
        },
        {
            offset: -540,
            name: language.get('timezone.timeN540'),
        },
        {
            offset: -480,
            name: language.get('timezone.timeN480'),
        },
        {
            offset: -420,
            name: language.get('timezone.timeN420'),
        },
        {
            offset: -360,
            name: language.get('timezone.timeN360'),
        },
        {
            offset: -300,
            name: language.get('timezone.timeN300'),
        },
        {
            offset: -270,
            name: language.get('timezone.timeN270'),
        },
        {
            offset: -240,
            name: language.get('timezone.timeN240'),
        },
        {
            offset: -210,
            name: language.get('timezone.timeN210'),
        },
        {
            offset: -180,
            name: language.get('timezone.timeN180'),
        },
        {
            offset: -120,
            name: language.get('timezone.timeN120'),
        },
        {
            offset: -60,
            name: language.get('timezone.timeN60'),
        },
        {
            offset: 0,
            name: language.get('timezone.time0'),
        },
        {
            offset: 60,
            name: language.get('timezone.time60'),
        },
        {
            offset: 120,
            name: language.get('timezone.time120'),
        },
        {
            offset: 180,
            name: language.get('timezone.time180'),
        },
        {
            offset: 210,
            name: language.get('timezone.time210'),
        },
        {
            offset: 240,
            name: language.get('timezone.time240'),
        },
        {
            offset: 240,
            name: language.get('timezone.time240'),
        },
        {
            offset: 240,
            name: language.get('timezone.time240'),
        },
        {
            offset: 270,
            name: language.get('timezone.time270'),
        },
        {
            offset: 300,
            name: language.get('timezone.time300'),
        },
        {
            offset: 330,
            name: language.get('timezone.time330'),
        },
        {
            offset: 345,
            name: language.get('timezone.time345'),
        },
        {
            offset: 360,
            name: language.get('timezone.time360'),
        },
        {
            offset: 360,
            name: language.get('timezone.time360'),
        },
        {
            offset: 390,
            name: language.get('timezone.time390'),
        },
        {
            offset: 420,
            name: language.get('timezone.time420'),
        },
        {
            offset: 480,
            name: language.get('timezone.time480'),
        },
        {
            offset: 525,
            name: language.get('timezone.time525'),
        },
        {
            offset: 540,
            name: language.get('timezone.time540'),
        },
        {
            offset: 570,
            name: language.get('timezone.time570'),
        },
        {
            offset: 600,
            name: language.get('timezone.time600'),
        },
        {
            offset: 630,
            name: language.get('timezone.time630'),
        },
        {
            offset: 660,
            name: language.get('timezone.time660'),
        },
        {
            offset: 690,
            name: language.get('timezone.time690'),
        },
        {
            offset: 720,
            name: language.get('timezone.time720'),
        },
        {
            offset: 765,
            name: language.get('timezone.time765'),
        },
        {
            offset: 780,
            name: language.get('timezone.time780'),
        },
        {
            offset: 840,
            name: language.get('timezone.time840'),
        },
    ];
};
/**
 * Get all custom fonts
 *
 * @returns list of font families to pass to Select menu (translated)
 */
export const getFontFamilyList = () => {
    return [
        {
            text: language.get('fontFamilies.helvetica'),
            value: 'helvetica, sans-serif',
        },
        {
            text: language.get('fontFamilies.arial'),
            value: 'arial, sans-serif',
        },
        {
            text: language.get('fontFamilies.arialBlack'),
            value: 'arial black, sans-serif',
        },
        {
            text: language.get('fontFamilies.verdana'),
            value: 'verdana, sans-serif',
        },
        {
            text: language.get('fontFamilies.tahoma'),
            value: "'Tahoma', sans-serif",
        },
        {
            text: language.get('fontFamilies.trebuchet'),
            value: 'trebuchet ms, sans-serif',
        },
        {
            text: language.get('fontFamilies.impact'),
            value: 'impact, sans-serif',
        },
        {
            text: language.get('fontFamilies.gillSans'),
            value: 'gill sans, sans-serif',
        },
        {
            text: language.get('fontFamilies.timesNewRoman'),
            value: 'times new roman, serif',
        },
        {
            text: language.get('fontFamilies.georgia'),
            value: 'georgia, serif',
        },
        {
            text: language.get('fontFamilies.palatino'),
            value: 'palatino, serif',
        },
        {
            text: language.get('fontFamilies.baskerville'),
            value: 'baskerville, serif',
        },
        {
            text: language.get('fontFamilies.andaleMono'),
            value: 'andale mono, monospace',
        },
        {
            text: language.get('fontFamilies.courier'),
            value: 'courier, monospace',
        },
        {
            text: language.get('fontFamilies.lucidaConsole'),
            value: "'Lucida Grane', monospace",
        },
        {
            text: language.get('fontFamilies.monaco'),
            value: 'monaco, monospace',
        },
        {
            text: language.get('fontFamilies.bradleyHand'),
            value: 'bradley hand, cursive',
        },
        {
            text: language.get('fontFamilies.brushScript'),
            value: 'brush script mt, cursive',
        },
        {
            text: language.get('fontFamilies.luminari'),
            value: 'luminari, fantasy',
        },
        {
            text: language.get('fontFamilies.comicSans'),
            value: 'comic sans ms, cursive',
        },
    ];
};
/** If androidAppStore and iosAppStore are not set Mobile intercept will not happen */
export const coreHelpUrls = {
    connectHelp: 'https://test-connect.asperasoft.com/',
    httpHelp: 'https://www.ibm.com/docs/en/aspera-http-gateway',
    nodeHelp: 'https://www.ibm.com/docs/en/ahts',
    androidAppStore: 'https://play.google.com/store/apps/details?id=com.ibm.software.aspera.mobile',
    iosAppStore: 'https://apps.apple.com/us/app/ibm-aspera/id1612281171',
    carbonColorTokens: 'https://carbondesignsystem.com/elements/color/tokens',
};
/** Carbon colors for autofill color picker. 16 colors are shown on color picker. */
export const carbonLightColors = [
    '#f4f4f4',
    '#0f62fe',
    '#ffffff',
    '#161616',
    '#24a148',
    '#f1c21b',
    '#0043ce',
    '#da1e28',
    '#4589ff',
    '#8d8d8d',
    '#d0e2ff',
    '#750e13',
    '#002d9c',
    '#6f6f6f',
    '#393939',
];
export const customThemingAdvancedKeys = [
    '$background',
    '$background-hover',
    '$background-active',
    '$background-selected',
    '$background-selected-hover',
    '$background-inverse',
    '$background-inverse-hover',
    '$background-brand',
    '$layer',
    '$layer-01',
    '$layer-02',
    '$layer-03',
    '$layer-hover',
    '$layer-hover-01',
    '$layer-hover-02',
    '$layer-hover-03',
    '$layer-active',
    '$layer-active-01',
    '$layer-active-02',
    '$layer-active-03',
    '$layer-selected',
    '$layer-selected-01',
    '$layer-selected-02',
    '$layer-selected-03',
    '$layer-selected-hover',
    '$layer-selected-hover-01',
    '$layer-selected-hover-02',
    '$layer-selected-hover-03',
    '$layer-selected-inverse',
    '$layer-selected-disabled',
    '$layer-accent',
    '$layer-accent-01',
    '$layer-accent-02',
    '$layer-accent-03',
    '$layer-accent-hover',
    '$layer-accent-hover-01',
    '$layer-accent-hover-02',
    '$layer-accent-hover-03',
    '$layer-accent-active',
    '$layer-accent-active-01',
    '$layer-accent-active-02',
    '$layer-accent-active-03',
    '$field',
    '$field-01',
    '$field-02',
    '$field-03',
    '$field-hover',
    '$field-hover-01',
    '$field-hover-02',
    '$field-hover-03',
    '$border-interactive',
    '$border-subtle',
    '$border-subtle-00',
    '$border-subtle-01',
    '$border-subtle-02',
    '$border-subtle-03',
    '$border-subtle-selected',
    '$border-subtle-selected-01',
    '$border-subtle-selected-02',
    '$border-subtle-selected-03',
    '$border-strong',
    '$border-strong-01',
    '$border-strong-02',
    '$border-strong-03',
    '$border-tile',
    '$border-tile-01',
    '$border-tile-02',
    '$border-tile-03',
    '$border-inverse',
    '$border-disabled',
    '$text-primary',
    '$text-secondary',
    '$text-placeholder',
    '$text-on-color',
    '$text-on-color-disabled',
    '$text-helper',
    '$text-error',
    '$text-inverse',
    '$text-disabled',
    '$link-01',
    '$link-primary',
    '$link-primary-hover',
    '$link-secondary',
    '$link-inverse',
    '$link-inverse-hover',
    '$link-inverse-active',
    '$link-inverse-visited',
    '$link-visited',
    '$icon-primary',
    '$icon-secondary',
    '$icon-on-color',
    '$icon-on-color-disabled',
    '$icon-interactive',
    '$icon-inverse',
    '$icon-disabled',
    '$button-primary',
    '$button-primary-hover',
    '$button-primary-active',
    '$button-secondary',
    '$button-secondary-hover',
    '$button-secondary-active',
    '$button-tertiary',
    '$button-tertiary-hover',
    '$button-tertiary-active',
    '$button-danger-primary',
    '$button-danger-secondary',
    '$button-danger-hover',
    '$button-danger-active',
    '$button-separator',
    '$button-disabled',
    '$notification-background-error',
    '$notification-background-success',
    '$notification-background-info',
    '$notification-background-warning',
    '$notification-action-hover',
    '$notification-action-tertiary-inverse',
    '$notification-action-tertiary-inverse-active',
    '$notification-action-tertiary-inverse-hover',
    '$notification-action-tertiary-inverse-text-on-color-disabled',
    '$support-error',
    '$support-success',
    '$support-warning',
    '$support-info',
    '$support-error-inverse',
    '$support-success-inverse',
    '$support-warning-inverse',
    '$support-info-inverse',
    '$support-caution-minor',
    '$support-caution-major',
    '$support-caution-undefined',
    '$focus',
    '$focus-inset',
    '$focus-inverse',
    '$interactive',
    '$highlight',
    '$toggle-off',
    '$overlay',
    '$skeleton-element',
    '$skeleton-background',
    '$tag-background-gray',
    '$tag-color-gray',
    '$tag-hover-gray',
    '$tag-border-gray',
    '$tag-background-cool-gray',
    '$tag-color-cool-gray',
    '$tag-hover-cool-gray',
    '$tag-border-cool-gray',
    '$tag-background-warm-gray',
    '$tag-color-warm-gray',
    '$tag-hover-warm-gray',
    '$tag-border-warm-gray',
    '$tag-background-red',
    '$tag-color-red',
    '$tag-hover-red',
    '$tag-border-red',
    '$tag-background-magenta',
    '$tag-color-magenta',
    '$tag-hover-magenta',
    '$tag-border-magenta',
    '$tag-background-purple',
    '$tag-color-purple',
    '$tag-hover-purple',
    '$tag-border-purple',
    '$tag-background-blue',
    '$tag-color-blue',
    '$tag-hover-blue',
    '$tag-border-blue',
    '$tag-background-cyan',
    '$tag-color-cyan',
    '$tag-hover-cyan',
    '$tag-border-cyan',
    '$tag-background-teal',
    '$tag-color-teal',
    '$tag-hover-teal',
    '$tag-border-teal',
    '$tag-background-green',
    '$tag-color-green',
    '$tag-hover-green',
    '$tag-border-green',
];
const exports = {
    defaultPageSizes,
    defaultEnglish,
    storageKeys,
    errorPrefix,
    fullPageModeClass,
    coreHelpUrls,
    getTimezoneList,
    getFontFamilyList,
    carbonLightColors,
    customThemingAdvancedKeys,
};
export default exports;
